<template>
    <v-card class="migration">
        <h3>{{ $t(title) }}</h3>
        <v-row>
            <v-col align="center">
                <div>
                    <v-btn data-cy="migrationGenerateButton" class="action" @click="getConf()">
                        1. {{ this.data && this.data.length > 0 ? 'Refresh' : 'Generate' }} export
                    </v-btn>
                </div>
            </v-col>
            <v-col align="center">
                <v-btn data-cy="migrationDownloadButton" class="cancel" @click="jsonExport" :disabled="!data || data.length === 0">
                    2. Download export
                    <v-icon>mdi-download</v-icon>
                </v-btn>
                <a id="downloadAnchorElem" style="display: none"></a>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-file-input id="migrationImportFile" height="20" v-bind:label="`Import file`" @change="onFileChange($event)" />
            </v-col>
            <v-col align="center">
                <div>
                    <v-btn data-cy="migrationImportButton" class="action" @click="importFile()">
                        Import
                        <v-icon>mdi-upload</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
import { mapMutations } from 'vuex';
import { SNACKBAR, SET_DISPLAY, SET_TEXT } from '../constants/snackbar';
import { api } from '@/utils/api';

export default {
    name: 'migration-card',
    props: ['title', 'dbName', 'moduleName'],
    data() {
        return {
            data: [],
            file: [],
            dialog: false
        };
    },
    methods: {
        ...mapMutations(SNACKBAR, [SET_DISPLAY, SET_TEXT]),
        async getConf() {
            const query = {};

            if (this.moduleName) {
                query.params = { moduleName: this.moduleName };
            }
            this.data = await api.get('exportDB', { dbName: this.dbName }, query, 'backoffice');
        },
        async jsonExport() {
            const dataStr = JSON.stringify(this.data);
            const dataUri = 'data:text/json;charset=utf-8,' + encodeURIComponent(dataStr);
            const link = document.getElementById('downloadAnchorElem');
            link.setAttribute('href', dataUri);
            link.setAttribute('download', `${this.dbName}.json`);
            link.click();
        },
        async onFileChange(file) {
            this.file = file;
        },
        async importFile() {
            if (!this.file) {
                this.setText('Choose a file to import.');
                this.setDisplay(true);
                return;
            }
            await this.readFile(this.file);
        },
        async readFile(file) {
            const reader = new FileReader();
            reader.onload = async e => {
                const formData = new FormData();
                formData.append('fileContent', e.target.result);
                const toSend = { dbName: this.dbName, params: {} };
                if (this.moduleName) {
                    toSend.params = { moduleName: this.moduleName };
                }
                const res = await api.post('import', formData, toSend, 'backoffice', { 'content-type': 'multipart/form-data' });
                if (res === 'ok') {
                    this.setText('Import OK !');
                    this.setDisplay(true);
                }
            };
            reader.readAsText(file);
        }
    }
};
</script>

<style lang="scss" scoped>
.clean {
    background-color: red !important;
    color: #fff !important;
    box-shadow: none !important;
    text-transform: none !important;
    font-weight: 700;
}

.v-icon {
    font-size: 1em;
    margin-left: 10px;
}

.migration {
    margin-top: 20px;
    h3 {
        padding: 15px;
    }
}
</style>
